import * as React from "react";
const SvgFiRrCircleBookOpen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-book-open_svg__a)">
      <path
        fill="#062147"
        d="M16.912 6.548a2.7 2.7 0 0 0-2.396-.439L13.2 6.49a3 3 0 0 0-1.2.674 3 3 0 0 0-1.2-.674l-1.316-.381a2.7 2.7 0 0 0-2.396.439A2.7 2.7 0 0 0 6 8.727v5.509c0 1.332.895 2.518 2.174 2.883l2.348.674a5.35 5.35 0 0 0 2.957 0l2.348-.673a3.01 3.01 0 0 0 2.175-2.884V8.727c0-.865-.396-1.659-1.088-2.179zM11 15.849l-2.276-.653a1 1 0 0 1-.724-.96V8.727c0-.23.105-.442.29-.58a.72.72 0 0 1 .434-.146c.067 0 1.52.41 1.52.41.445.129.757.543.757 1.006zm5-1.613c0 .443-.298.839-.725.961L13 15.849V9.417c0-.463.312-.877.757-1.006l1.316-.381a.72.72 0 0 1 .637.117c.185.138.29.35.29.58zM12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-book-open_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleBookOpen;
